import React, { useState, useEffect } from "react";
import { Container, Form, Modal } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
// import "./KycPage.css"; // For input-error CSS
import { IoCloseSharp } from "react-icons/io5";

const KycPage = () => {
  const navigate = useNavigate();
  const userId = localStorage.getItem("user_id");
  const token = localStorage.getItem("token");
  const mobile = localStorage.getItem("mobile");
  const email = localStorage.getItem("email");
  const [states, setStates] = useState([]);
  const [cities, setCities] = useState([]);
  const [profileData, setProfileData] = useState({
    id: userId,
    username: "",
    email: email,
    mobile: mobile,
    state: "",
    city: "",
    kyc: "success",
  });

  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [showModal, setShowModal] = useState(true);

  // Fetch states
  useEffect(() => {
    const fetchStates = async () => {
      try {
        const response = await fetch(
          `${process.env.REACT_APP_BASE_URL}/state-list`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
          }
        );
        const data = await response.json();
        if (data.status === "1") setStates(data.data);
      } catch (err) {
        console.error("State list fetch error:", err);
      }
    };
    fetchStates();
  }, [token]);

  // Fetch cities when state changes
  useEffect(() => {
    if (!profileData.state) {
      setCities([]);
      setProfileData({ ...profileData, city: "" });
      return;
    }
    const fetchCities = async () => {
      try {
        const response = await fetch(
          `${process.env.REACT_APP_BASE_URL}/city-list`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify({ state_id: profileData.state }),
          }
        );
        const data = await response.json();
        if (data.status === "1") setCities(data.data);
      } catch (err) {
        console.error("City list fetch error:", err);
      }
    };
    fetchCities();
  }, [profileData.state, token]);

  const validate = () => {
    const newErrors = {};
    if (!profileData.username.trim()) newErrors.username = true;
    if (!profileData.email.trim()) newErrors.email = true;
    if (!profileData.mobile.trim()) newErrors.mobile = true;
    if (!profileData.state.trim()) newErrors.state = true;
    if (!profileData.city.trim()) newErrors.city = true;

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSaveProfile = async () => {
    if (!validate()) return;

    setLoading(true);
    try {
      const res = await axios.post(
        `${process.env.REACT_APP_BASE_URL}/edit-profile`,
        profileData, // yaha pe body data jayega
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (res.data.status == 1) {
        toast.success("Profile updated successfully");
        setShowModal(false);
        window.location.reload();
      } else {
        toast.error(res.data.message || "Profile update failed");
      }
    } catch (err) {
      toast.error("Something went wrong");
    } finally {
      setLoading(false);
    }
  };

  const handleCloseModal = () => {
    setShowModal(false);
  };

  return (
    <Container className="py-5">
      <ToastContainer />
      <Modal show={showModal} backdrop="static" centered>
        <Modal.Header className="d-flex justify-content-between">
          <Modal.Title>
            <h5>Complete Your Profile (KYC)</h5>
          </Modal.Title>
          <div className="fs-3 pointer" onClick={handleCloseModal}>
            <IoCloseSharp />
          </div>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group className="mb-2">
              <Form.Label>Username</Form.Label>
              <Form.Control
                type="text"
                value={profileData.username}
                onChange={(e) =>
                  setProfileData({ ...profileData, username: e.target.value })
                }
                className={errors.username ? "input-error" : ""}
              />
            </Form.Group>

            <Form.Group className="mb-2">
              <Form.Label>Email</Form.Label>
              {/* <Form.Control
                type="email"
                value={profileData.email}
                onChange={(e) =>
                  setProfileData({ ...profileData, email: e.target.value })
                }
                className={errors.email ? "input-error" : ""}
              /> */}
              <Form.Control
                type="text"
                value={profileData.email}
                readOnly
                className={errors.email ? "input-error" : ""}
              />
            </Form.Group>
            <Form.Group className="mb-2">
              <Form.Label>Mobile</Form.Label>
              <Form.Control
                type="text"
                value={profileData.mobile}
                readOnly
                className={errors.mobile ? "input-error" : ""}
              />
            </Form.Group>
            <Form.Group className="mb-2">
              <Form.Label>State</Form.Label>
              <Form.Select
                value={profileData.state}
                onChange={(e) =>
                  setProfileData({ ...profileData, state: e.target.value })
                }
                className={errors.state ? "input-error" : ""}
              >
                <option value="">Select State</option>
                {states.map((state) => (
                  <option key={state.id} value={state.id}>
                    {state.name}
                  </option>
                ))}
              </Form.Select>
            </Form.Group>

            <Form.Group className="mb-2">
              <Form.Label>City</Form.Label>
              <Form.Select
                value={profileData.city}
                onChange={(e) =>
                  setProfileData({ ...profileData, city: e.target.value })
                }
                className={errors.city ? "input-error" : ""}
                disabled={!profileData.state}
              >
                <option value="">Select City</option>
                {cities.map((city) => (
                  <option key={city.id} value={city.id}>
                    {city.name}
                  </option>
                ))}
              </Form.Select>
            </Form.Group>
          </Form>
        </Modal.Body>

        <Modal.Footer>
          <button
            className="educate-btn"
            onClick={handleSaveProfile}
            disabled={loading}
          >
            <span className="educate-btn__curve"></span>
            {loading ? "Saving..." : "Save & Continue"}
          </button>
        </Modal.Footer>
      </Modal>
    </Container>
  );
};

export default KycPage;
